import getSalesChannelsBySellerId from './getSalesChannelsBySellerId';

export const ActorService = { getSalesChannelsBySellerId };
